<template>
  <v-navigation-drawer
    app
    temporary
    v-model="drawer"
    :right="!$vuetify.rtl"
    style="direction:ltr"
    class="grey lighten-4"
  >
    <v-list class="pt-0 grey lighten-4">
      <div class="flex-column py-5 pl-2 v-middle" style="background:#1b1464">
        <img :src="PTS_LOGO" style="width:110px" />
      </div>
      <v-divider />

      <v-list-tile to="/profile">
        <v-list-tile-action>
          <v-icon v-html="'person'" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="subheding">{{
            $t("my_profile")
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="logout">
        <v-list-tile-action>
          <v-icon v-html="'logout'" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="subheding">{{
            $t("logout")
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-footer fixed height="100">
        <v-layout row wrap justify-start class="pl-4">
          <div class="my-1 di-flex v-middle">
            <v-icon size="22" color="blue darken-1">mail</v-icon>
            <span class="mx-3 body-1">info@pts.af</span>
          </div>
          <div class="my-1 di-flex v-middle">
            <v-icon size="22" color="teal darken-1">perm_phone_msg</v-icon>
            <span class="ml-3 mr-2 body-1">0797 103 103</span>
            <strong>-</strong>
            <span class="ml-2 body-1">0797 106 106</span>
          </div>
        </v-layout>
      </v-footer>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: ["appDrawer"],
  computed: {
    drawer: {
      get: ({ appDrawer }) => appDrawer,
      set(val) {
        this.$emit("update:appDrawer", val);
      }
    }
  },
  methods: {
    logout() {
      let clear = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("currentUser");
        delete this.axios.defaults.headers.common["Authorization"];
        this.$router.push("/auth/login");
      };
      this.axios
        .post("logout")
        .then(clear())
        .catch(clear());
    }
  }
};
</script>
